export default __webpack_public_path__ + "static/media/sked_banner.1b90084a.gif";